import { Box } from '@mantine/core';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/author/_author/dictionary/_dictionary')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.dictionaries' },
  },
});

function RouteComponent() {
  return (
    <Box p="md">
      <Outlet />
    </Box>
  );
}
